
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.692 2H7.256A2.276 2.276 0 005 4.256v.821h13.949v-.82A2.277 2.277 0 0016.692 2zM5 5.897h13.949V16.73H5V5.896zM5 20.257a2.276 2.276 0 002.257 2.256h9.477a2.276 2.276 0 002.256-2.256v-2.75H5v2.75zm6.975-1.682c.78 0 1.436.656 1.436 1.436 0 .78-.656 1.436-1.436 1.436-.78 0-1.436-.657-1.436-1.436 0-.78.656-1.436 1.436-1.436z","fill":"#B5B8B5"}})])
          )
        }
      }
    